import * as React from 'react';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, TimePicker, DatePicker, DateTimePicker } from '@material-ui/pickers';
import PropTypes from 'prop-types';
import SignaturePad from "react-signature-canvas";
import {GreyButton} from "./ButtonsConstants";
import { t } from '../../i18n';

class MTableEditField2 extends React.Component {

    constructor(props) {
        super(props);
        this.onChangeHandler = this.onChangeHandler.bind(this);
    }

    getProps() {
        const { columnDef, rowData, defaultData, onRowDataChange,  ...props } = this.props;
        return props;
    }

    renderLookupField() {
        return (
            <Select
                {...this.getProps()}
                value={this.props.value === undefined ? '' : this.props.value}
                onChange={event => this.props.onChange(event.target.value)}
                style={{
                    fontSize: 13,
                }}
            >
                {Object.keys(this.props.columnDef.lookup).map(key => (
                    <MenuItem key={key} value={key}>{this.props.columnDef.lookup[key]}</MenuItem>)
                )}
            </Select>
        );

    }

    renderBooleanField() {
        return (
            <Checkbox
                {...this.getProps()}
                value={String(this.props.value)}
                checked={Boolean(this.props.value)}
                onChange={event => this.props.onChange(event.target.checked)}
                style={{
                    paddingLeft: 0,
                    paddingTop: 0,
                    paddingBottom: 0
                }}
            />
        );
    }

    renderDateField() {
        return (
            <React.Fragment>
                {this.props.columnDef.optional &&
                <FormControlLabel
                    control={
                        <Checkbox
                            {...this.getProps()}
                            value={String(this.props.optionalValue === undefined ? false : this.props.optionalValue)}
                            checked={Boolean(this.props.optionalValue === undefined ? false : this.props.optionalValue)}
                            onChange={ event => { this.props.onOptionalDateChange(event); this.props.onChange(undefined); }}
                            style={{
                                paddingBottom: "7px"
                            }}
                        />
                    }
                    label={ t('common.na') }/>
                }
                {!this.props.optionalValue &&
                    <React.Fragment>{this.props.columnDef.optional && <br/>}
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <DatePicker
                                {...this.getProps()}
                                format="dd.MM.yyyy"
                                placeholder={ t('context.common.date') }
                                value={this.props.value || null}
                                onChange={this.props.onChange}
                                clearable
                                InputProps={{
                                    style: {
                                        fontSize: 13,
                                    }
                                }}
                            />
                        </MuiPickersUtilsProvider>
                    </React.Fragment>
                }
            </React.Fragment>
        );
    }

    renderTimeField() {
        return (
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <TimePicker
                    {...this.getProps()}
                    format="HH:mm:ss"
                    value={this.props.value || null}
                    onChange={this.props.onChange}
                    clearable
                    InputProps={{
                        style: {
                            fontSize: 13,
                        }
                    }}
                />
            </MuiPickersUtilsProvider>
        );
    }

    renderDateTimeField() {
        return (
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DateTimePicker
                    {...this.getProps()}
                    format="dd.MM.yyyy HH:mm:ss"
                    value={this.props.value || null}
                    onChange={this.props.onChange}
                    clearable
                    InputProps={{
                        style: {
                            fontSize: 13,
                        }
                    }}
                />
            </MuiPickersUtilsProvider>
        );
    }

    renderTextField() {
        let defaultValue = '';
        if (this.props.tableData === undefined && this.props.value === undefined && this.props.defaultData !== undefined && this.props.defaultData !== null && this.props.defaultData[this.props.columnDef.field] !== undefined) {
            console.log('assigning value');
            defaultValue = this.props.defaultData[this.props.columnDef.field];
        }
        return (
            <TextField
                {...this.getProps()}
                style={this.props.columnDef.type === 'numeric' ? { float: 'right' } : {}}
                type={this.props.columnDef.type === 'numeric' ? 'number' : 'text'}
                placeholder={this.props.columnDef.title}
                value={this.props.value === undefined ? defaultValue : this.props.value}
                onChange={event => this.props.onChange(event.target.value)}
                multiline={this.props.columnDef.type === 'textarea'}
                rows="4"
                InputProps={{
                    style: {
                        fontSize: 13,
                    }
                }}
            />
        );
    }

    renderCurrencyField() {
        return "ok";
    }

    onChangeHandler = (event) => {
        let file = event.target.files[0];
        // if return true allow to setState
        this.props.onChange(file);
        /* console.log(this.validateSize(event));
        if(this.validateSize(event)){
            console.log(file);
            // if return true allow to setState
            this.setState({
                selectedFile: file
            });

        }*/
    };

    renderFileUploadField() {
        return (
            <div>
                { this.props.rowData && this.props.rowData.fileName && <span>{this.props.rowData.fileName}</span> }
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="file"
                    name="file"
                    onChange={ this.onChangeHandler }
                    type="file"
                />
            </div>
        );
    }

    renderSignatureField() {
        return (
            <div style={{ clear: "both", borderStyle: "ridge", borderWidth: "1px", padding: "0px", display: "table-cell" }}>
                <SignaturePad
                    canvasProps={{ width: "250px", height: "150px" }}
                    onEnd={() => { console.log('onEnd called'); this.props.onChange(this.sigPad.toDataURL('image/png')); }}
                    ref={(ref) => {
                        this.sigPad = ref;
                        if (this.props.value && this.sigPad) {
                            this.sigPad.fromDataURL(this.props.value, { width: 250, height: 150})
                        }
                    }}
                />
                <GreyButton onClick={() => this.sigPad.clear()}>
                    { t('common.clear') }
                </GreyButton>
            </div>
        );
    }

    render() {
        let component = "ok";

        if (this.props.columnDef.lookup) {
            component = this.renderLookupField();
        }
        else if (this.props.columnDef.type === "boolean") {
            component = this.renderBooleanField();
        }
        else if (this.props.columnDef.type === "date") {
            component = this.renderDateField();
        }
        else if (this.props.columnDef.type === "time") {
            component = this.renderTimeField();
        }
        else if (this.props.columnDef.type === "datetime") {
            component = this.renderDateTimeField();
        }
        else if (this.props.columnDef.type === "currency") {
            component = this.renderCurrencyField();
        }
        else if (this.props.columnDef.type === "fileupload") {
            component = this.renderFileUploadField();
        }
        else if (this.props.columnDef.type === "signature") {
            component = this.renderSignatureField();
        }
        else {
            component = this.renderTextField();
        }

        return component;

    }
}

MTableEditField2.propTypes = {
    value: PropTypes.any,
    optionalValue: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    onOptionalDateChange: PropTypes.func.isRequired,
    columnDef: PropTypes.object.isRequired
};

export default MTableEditField2;

